// @flow

export const toRawPhoneNumber = (phone: string, dialCode: string) =>
  phone.replace(/[^0-9]+/g, '').slice(dialCode.length);
